import { getContext } from '@fiverr-private/fiverr_context';
import localeStorage from '../../utils/recentlyViewedPages/localStorage';
import { GIG_GRID_LRG, GIG_GRID_MED, GIG_GRID_SML, GIG_GRID_XLRG } from '../shared/Grid';

/**
 * @constant
 * @type {object}
 * @param {string} appName personalized section application name
 * @param {string} perseusName perseus name
 * */
export const BASE_PARAMS = {
    appName: 'gig_page',
    perseusName: 'gig_page'
};

/**
 * @constant
 * @type {object}
 * @param {string} COMPARE personalized section compare name
 * @param {string} EXPLORE personalized section explore name
 * */
export const SECTION_NAMES = {
    COMPARE: 'compare',
    EXPLORE: 'explore'
};

/**
 * @private
 * @constant
 * @type {object}
 * @param {object} COMPARE personalized section compare base data
 * @param {object} EXPLORE personalized section explore base data
 * */
const sectionsConfig = {
    [SECTION_NAMES.COMPARE]: {
        ...BASE_PARAMS,
        sliderBaseNum: 2,
        sliderBreakpoints: [
            {
                breakpoint: GIG_GRID_XLRG,
                slides: 2,
                slidesToScroll: 2
            },
            {
                breakpoint: GIG_GRID_LRG,
                slides: 3,
                slidesToScroll: 3
            },
            {
                breakpoint: GIG_GRID_MED,
                slides: 2,
                slidesToScroll: 2
            },
            {
                breakpoint: GIG_GRID_SML,
                slides: 1,
                slidesToScroll: 1
            }
        ]
    },
    [SECTION_NAMES.EXPLORE]: {
        ...BASE_PARAMS
    }
};

/**
 * Get configuration for personalized section
 * @param {string} sectionName personalized section name
 * @param {number} gigId
 * @return {object} personalized section configuration
 * */
export const getConfig = (sectionName, gigId) => {
    const { queryParameters: { ref = '' } = {} } = getContext();
    const recommendationsParams = {
        gig: {
            id: gigId
        },
        context_filters: ref
    };

    switch (sectionName){
        case SECTION_NAMES.COMPARE:
            return {
                sectionName,
                ...sectionsConfig[sectionName],
                recommendationsParams
            };
        case SECTION_NAMES.EXPLORE:
            return {
                sectionName,
                ...sectionsConfig[sectionName],
                recommendationsParams: {
                    ...recommendationsParams,
                    browse_history: localeStorage.getGigIds(gigId)
                }
            };
        default:
            return BASE_PARAMS;
    }
};
